<template>
	<div class="Editorial3">
		<div class="mt-5">
			<div class="container">
				<h1>{{ $t('navigationEditorial.editorial3.title') }}</h1>
				<div class="row align-items-center">
					<div class="py-5 col-9">
						<h4 class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz3') }}
						</h4>
						<div class="mb-5">
							{{ $t('navigationEditorial.editorial3.content.absatz4') }}
						</div>
						<h4 class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz5') }}
						</h4>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz6') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz7') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz8') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz9') }}
						</div>
						<div class="Zitat mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz10') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz11') }}
						</div>
						<div class="Zitat mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz12') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz13') }}
						</div>
						<div class="Zitat mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz14') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz15') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz16') }}
						</div>
						<div class="mb-5">
							{{ $t('navigationEditorial.editorial3.content.absatz17') }}
						</div>
						<h4 class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz18') }}
						</h4>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz19') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz20') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz21') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz22') }}
						</div>
						<div class="mb-5">
							{{ $t('navigationEditorial.editorial3.content.absatz23') }}
						</div>
						<h4 class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz24') }}
						</h4>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz25') }}
							<router-link :to="{ name: 'Grad1Postfight1' }">{{
								$t('navigationEditorial.editorial3.content.absatz25a')
							}}</router-link>
							{{ $t('navigationEditorial.editorial3.content.absatz25b') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz26') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz27') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz28') }}
						</div>
						<div class="Zitat mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz29') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz30') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz31') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz32') }}
						</div>
						<div class="Zitat mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz33') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz34') }}
						</div>
						<div class="Zitat mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz35') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz36') }}
						</div>
						<div class="Zitat mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz37') }}
						</div>
						<div class="mb-5">
							{{ $t('navigationEditorial.editorial3.content.absatz38') }}
						</div>
						<h4 class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz39') }}
						</h4>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz40') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz41') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz42') }}
						</div>
						<div class="Zitat mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz43') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz44') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz45') }}
						</div>
						<div class="Zitat mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz46') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz47') }}
						</div>
						<div class="Zitat mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz48') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz49') }}
						</div>
						<div class="Zitat mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz50') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial3.content.absatz51') }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import editorialMixin from '@/views/editorial/editorialMixin.js'

export default {
	name: 'Editorial3',
	mixins: [editorialMixin]
}
</script>
